export const VOLATILE_STALE_TIME = 60000;
export const DETAIL_STALE_TIME = 900000;
export const TAXONOMY_STALE_TIME = 3600000;
